import { Component, createRef, Fragment, h } from 'preact';
import ReactHintFactory from 'react-hint';
import { TAB_KEYCODE, PROVISIONS, DEFAULT_POWERED_BY_TEXT } from '../../../common/constants';
import QuestionIcon from '../QuestionIcon.js';
import {
  StyledFooterDiv,
  StyledPoweredByLogoImage,
  StyledPoweredByAnchorTag,
} from './StyledFooter';
const ReactHint = ReactHintFactory({ createElement: h, Component });
const MEDALLIA_LOGO_PATH =
  'assets/images/kampyle/CommandCenterInvitationLogo.svg';
function preventDefault(ev) {
  ev.preventDefault();
  ev.stopPropagation();
}

export default class FooterSection extends Component {
  constructor(props) {
    super(props);
    this.iconElemRef = createRef();
    this.getInviteLogoUrl = this.getInviteLogoUrl.bind(this);
    this.isWcagCompatibleLogo =
      props.provisions[PROVISIONS.ALIGN_LOGO_MARKUP] && props.isWCAG;
  }

  componentDidMount() {
    const elem = this.iconElemRef.current;
    if (!elem) return;

    if (!this.props.provisions[PROVISIONS.NEW_MODAL_DIALOGS]) {
      this.base.addEventListener('keydown', ev => {
        if ((ev.which || ev.keyCode === TAB_KEYCODE) && !ev.shiftKey) {
          document.getElementById('kplDeferButton').focus();
          preventDefault(ev);
        }
      });
    }
  }

  getInviteLogoUrl() {
    if (window.kplConfig) {
      return `${window.kplConfig.prefix}${window.kplConfig.resourcesPrefix}${MEDALLIA_LOGO_PATH}`;
    } else {
      return `${this.props.globalResourcesUrl}/CommandCenterInvitationLogo.svg`;
    }
  }

  getPoweredByClasses() {
    const baseClass = this.isWcagCompatibleLogo
      ? 'powered-by-link'
      : 'link-text link-text-color';

    return `${baseClass} ${
      this.props.isWCAG ? 'neb-wcag wcag-powered-by-contrast' : ''
    }`;
  }

  getHelpLinkClasses() {
    return `question-circle kpl-tooltip kpl-invitation-tooltip pull-left ${
      this.props.isWCAG ? 'neb-wcag' : ''
    }`;
  }

  renderPoweredByLogo() {
    const { isDirectionRtl, isWCAG, poweredByTranslation, isInviteReflow } = this.props;
    const medalliaLogo = this.getInviteLogoUrl();
    const PoweredByText = poweredByTranslation || DEFAULT_POWERED_BY_TEXT;

    return this.isWcagCompatibleLogo ? (
      <StyledPoweredByAnchorTag
        target="_blank"
        href="https://www.medallia.com"
        isWCAG={isWCAG}
        isDirectionRtl={isDirectionRtl}
        isInviteReflow={isInviteReflow}
        isWcagCompatibleLogo
        className={this.getPoweredByClasses()}
      >
        {PoweredByText}
        <StyledPoweredByLogoImage
          alt="Medallia"
          src={medalliaLogo}
          className="powered-by-image"
          isInviteReflow={isInviteReflow}
        />
      </StyledPoweredByAnchorTag>
    ) : (
      <StyledPoweredByAnchorTag
        target="_blank"
        href="https://www.medallia.com"
        isWCAG={isWCAG}
        isDirectionRtl={isDirectionRtl}
        dir={isDirectionRtl ? 'rtl' : 'ltr'}
        aria-label={`${PoweredByText} Medallia`}
        className={this.getPoweredByClasses()}
        isInviteReflow={isInviteReflow}
      >
        {PoweredByText}
        <StyledPoweredByLogoImage
          src={medalliaLogo}
          className="footerImg"
          role="presentation"
          isInviteReflow={isInviteReflow}
        />
      </StyledPoweredByAnchorTag>
    );
  }

  renderQuestionTooltip({ toolTipText, provisions, isDirectionRtl, isInviteReflow, horizontal }) {
    return !toolTipText ? null : (
      <Fragment>
        <ReactHint
          position={isDirectionRtl ? 'left' : 'right'}
          events
          isInviteReflow={isInviteReflow}
          horizontal={horizontal}
        />
        <QuestionIcon
          provisions={provisions}
          ref={this.iconElemRef}
          toolTipText={toolTipText || null}
          className={this.getHelpLinkClasses()}
          isDirectionRtl={isDirectionRtl}
          isInviteReflow={isInviteReflow}
        />
      </Fragment>
    )
  }

  render() {
    const {
      isDirectionRtl,
      isWCAG,
      isInviteReflow,
      horizontal,
      visibility,
    } = this.props;

    return (
      <StyledFooterDiv
        isWCAG={isWCAG}
        isDirectionRtl={isDirectionRtl}
        className="footerCls"
        isInviteReflow={isInviteReflow}
        horizontal={horizontal}
        visibility={visibility}
      >
        {isInviteReflow ? (
          <div className='tooltip-container'>
            {this.renderQuestionTooltip(this.props)}
          </div>
        ) : this.renderQuestionTooltip(this.props)
        }
        {this.renderPoweredByLogo()}
      </StyledFooterDiv>
    );
  }
}

FooterSection.defaultProps = {
  provisions: {},
};
